var _path, _path2, _line, _line2, _path3, _path4, _polyline, _polyline2, _path5, _path6, _polyline3, _polyline4, _polygon, _line3, _line4, _ellipse, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrustaceanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC6049",
    d: "M112.3,46.6C105.7,23.3,83,5.5,58.2,8.3c-0.1-0.2-0.3-0.2-0.6-0.2C35,10.5,16.6,26.8,9.8,48.1 c-0.8,2.7-1.5,5.4-2,8.2c-0.2,0.1-0.3,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3C6.3,67.5,6.7,74.9,8.7,82 c0.8,2.9,2,5.6,3.4,8.1c0,0.2,0.1,0.4,0.3,0.5c3.8,6.5,9.4,11.8,16,16.1c9.8,6.4,20.5,10.8,32.3,10.7c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c9-0.9,17.7-3.9,25.3-8.7c9.9-6.2,17-14.6,20.6-25.7C115.1,71,115.7,58.3,112.3,46.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.2267,
    y1: 47.1699,
    x2: 131.2436,
    y2: 84.2839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06984988,
    style: {
      stopColor: "#75251B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1757,
    style: {
      stopColor: "#7D281E",
      stopOpacity: 0.9841
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#933226",
      stopOpacity: 0.9586
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5582,
    style: {
      stopColor: "#B94534",
      stopOpacity: 0.9269
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7376,
    style: {
      stopColor: "#E35B45",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8053,
    style: {
      stopColor: "#EC6049"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M112.3,46.6c-0.3-1.1-0.7-2.2-1.1-3.3l-26-13.8l-8.8,12.1L40.3,27.6l-5.5,11.7l28.7,34.9L51.8,97.8 L91.3,108c9.6-6.2,16.6-14.4,20.1-25.3C115.1,71,115.7,58.3,112.3,46.6z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 54.6,
    y1: 29.5,
    x2: 57.4,
    y2: 42.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 66.3,
    y1: 29.5,
    x2: 64.4,
    y2: 42.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M70,55.7c11.9-0.2,10.2-12.8,10.2-12.8s13-4.2,6.2-12.1c0,0-1.9-2.9-4.8-3.2l-0.8,7.3l-7.1-0.5c0,0-1.7,4,4.5,8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M80.2,42.9c0,0,13-4.2,6.2-12.1c0,0-1.9-2.9-4.8-3.2l-0.8,7.3l-7.1-0.5c0,0-1.7,4,4.5,8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 83.6,59.5 76.6,63.8 69.4,63.8 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 83,67.1 76.7,71.1 66.9,71.1 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M51.2,55.7C39.3,55.5,41,42.9,41,42.9s-13-4.2-6.2-12.1c0,0,1.9-2.9,4.8-3.2l0.8,7.3l7.1-0.5c0,0,1.7,4-4.5,8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41,42.9c0,0-13-4.2-6.2-12.1c0,0,1.9-2.9,4.8-3.2l0.8,7.3l7.1-0.5c0,0,1.7,4-4.5,8"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 37.8,59.5 44.8,63.8 51.8,63.8 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 38.4,67.1 44.7,71.1 54.5,71.1 "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 64.4,88 64.4,75 57,75.5 57,86.8 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#EC6049",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 58.2,
    y1: 78.4,
    x2: 64.4,
    y2: 78.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#EC6049",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 58.2,
    y1: 83.4,
    x2: 64.4,
    y2: 83.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 60.6,
    cy: 58.2,
    rx: 9.4,
    ry: 16.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M61.6,88.3c0,0,7.7,0.9,7.8,6.7c0,0,0.3,3.1-5.8,2.6l-3-0.3l-3,0.3c-6.1,0.5-5.8-2.6-5.8-2.6c0.1-5.8,7.8-6.7,7.8-6.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#EC6049",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M58.5,44.4c0,0-5.1,3.2-5,16.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrustaceanIcon);
export default __webpack_public_path__ + "static/media/crustacean_icon.6bd4d1728db2fdb513a7a3ac27ea14fc.svg";
export { ForwardRef as ReactComponent };